// Pure helpers for the weirdx bulk item import (Artículos En Bola).
// Extracted so the import mapping can be unit-tested without Angular.

export interface ImportItemRow
{
	categoria?: unknown;
	subcategoria?: unknown;
	prodoserv?: unknown;
	unidad?: unknown;
	measurement_unit?: unknown;
	codigo?: unknown;
}

export function normalizeImportName(value: unknown): string
{
	if( value === null || value === undefined )
		return '';

	return ('' + value).replace(/\s+/g, ' ').trim().toLowerCase();
}

// Items belong to the subcategory when present, otherwise to the category.
// The previous inline code used the subcategory only, so rows with an empty
// subcategoria (like the whole La Catrina excel) ended up with '' and lost
// their category.
export function resolveImportCategoryName(row: ImportItemRow): string
{
	return normalizeImportName(row.subcategoria) || normalizeImportName(row.categoria);
}

function normalizeNullableString(value: unknown): string | null
{
	if( value === null || value === undefined )
		return null;

	let s = ('' + value).trim();
	return s === '' ? null : s;
}

export function normalizeImportCode(value: unknown): string | null
{
	return normalizeNullableString(value);
}

export function normalizeImportClaveSat(value: unknown): string | null
{
	return normalizeNullableString(value);
}

export function normalizeImportMeasurementUnit(row: ImportItemRow): string | null
{
	return normalizeNullableString(row.measurement_unit) || normalizeNullableString(row.unidad);
}

// Chunk an array keeping every element, including the remainder and lists
// shorter than the chunk size. The previous inline loop only pushed full
// 100-item chunks, so excels with <100 rows uploaded nothing at all.
export function chunkArray<T>(items: T[], size: number = 100): T[][]
{
	if( size <= 0 )
		return items.length ? [items.slice()] : [];

	let chunks: T[][] = [];

	for(let i = 0; i < items.length; i += size)
		chunks.push(items.slice(i, i + size));

	return chunks;
}
